/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentDetailsInformation: "order-block-information",
  shipmentDetailsBrokerCustomer: "order-block-broker-customer",
  shipmentDetailsPickupDelivery: "order-block-pickup-delivery",
  shipmentDetailsTrailerRequirements: "order-block-trailer-requirements",
  shipmentDetailsLiquidCommodities: "order-block-liquid-commodities",
  shipmentDetailsRecalculate: "shipment-details-recalculate",
  shipmentDetailsGeneralInfo: "shipment-details-general-info",
  shipmentDetailsTrip: "shipment-details-trip",
  shipmentDetailsDocumentsAndNotes: "shipment-details-documents-and-notes",
  shipmentDetailsInvoicing: "shipment-details-invoicing",
  shipmentDetailsHistory: "shipment-details-history",
  shipmentDetailsEditNotes: "shipment-details-edit-notes",
  shipmentDetailsResendDocuments: "shipment-details-resend-documents",
  shipmentDetailsUploadDocuments: "shipment-details-upload-documents",
  shipmentDetailsAddCharge: "shipment-details-add-charge",
  shipmentDetailsAddExpense: "shipment-details-add-expense",
  shipmentDetailsEvents: "order-block-events",
} as const;
